import {
  ProfileDto,
  UpdateProfileDto,
  UpdateExpertisesDto,
  UpdateIndustriesDto,
  ExpertiseDto,
  IndustryDto,
  TeamMemberDto,
} from '@paladin-monorepo/common';
import API, { API_URL } from '../api';

export const profileApi = {
  // Get profile
  async getProfile(): Promise<ProfileDto> {
    return API.get<ProfileDto>('/me/profile').then((res) => res.data);
  },

  // Update profile
  async updateProfile(dto: UpdateProfileDto): Promise<ProfileDto> {
    return API.patch<ProfileDto>('/me/profile', dto).then((res) => res.data);
  },

  // Get expertises
  async getExpertises(): Promise<ExpertiseDto[]> {
    return API.get<ExpertiseDto[]>('/me/expertises').then((res) => res.data);
  },

  // Update expertises
  async updateExpertises(dto: UpdateExpertisesDto): Promise<ExpertiseDto[]> {
    return API.patch<ExpertiseDto[]>('/me/expertises', dto).then((res) => res.data);
  },

  async getIndustries(): Promise<IndustryDto[]> {
    return API.get<IndustryDto[]>('/me/industries').then((res) => res.data);
  },

  async updateIndustries(dto: UpdateIndustriesDto): Promise<IndustryDto[]> {
    return API.patch<IndustryDto[]>('/me/industries', dto).then((res) => res.data);
  },

  // Upload profile photo
  async uploadPhoto(file: File): Promise<ProfileDto> {
    const formData = new FormData();
    formData.append('photo', file);
    return API.post<ProfileDto>('/me/profile/photo', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }).then((res) => res.data);
  },

  async getProfilePhoto(): Promise<string> {
    return API.get<string>('/me/profile/photo').then((res) => res.data);
  },

  getMyPhotoUrl(): string {
    return API_URL + '/me/profile/photo';
  },

  getProfilePhotoUrl(id: string): string {
    return API_URL + '/party/' + id + '/photo';
  },

  // Get team members
  async getTeam(): Promise<TeamMemberDto[]> {
    return API.get<TeamMemberDto[]>('/me/team').then((res) => res.data);
  },
};

